"use client";

import { Button } from "@/components/ui/button";
import { useAppContext } from "@/contexts/app";
import { sharedHeaderSignInButtonClassName } from "@/components/sign/styles";
import { useTranslations } from "next-intl";

export default function SignIn() {
  const t = useTranslations();
  const { setShowSignModal } = useAppContext();

  return (
    <Button
      type="button"
      onClick={() => setShowSignModal(true)}
      data-testid="shared-sign-in-button"
      className={sharedHeaderSignInButtonClassName}
    >
      {t("user.sign_in")}
    </Button>
  );
}
